import { render, staticRenderFns } from "./Promotional.vue?vue&type=template&id=5d0beb58&scoped=true"
import script from "./Promotional.vue?vue&type=script&lang=js"
export * from "./Promotional.vue?vue&type=script&lang=js"
import style0 from "./Promotional.vue?vue&type=style&index=0&id=5d0beb58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0beb58",
  null
  
)

export default component.exports